module.exports = __webpack_public_path__ + "img/forest-summer.1ddf1726.webp";